import { IApiEntitySmpAgTag } from "@smp/api";
import { UiAvatar, UiBox, UiChip } from "@smp/ui";
import { dataArraySieve } from "@smp/utils";
import { useCallback, useMemo } from "react";

import { useSmpAgTranslation } from "@/hooks/use_smp_ag_translation";
import { useQueryPolotnoTagsAll } from "@/queries";

import { useContextStickers } from "../../../../context";
import classes from "./selected_tags.module.css";

export const SelectedTags = () => {
  const getTranslation = useSmpAgTranslation();

  const {
    actions: { updateSelectedTags },
    state: { selectedTags },
  } = useContextStickers();

  const {
    data: { normalized: normalizedTags },
  } = useQueryPolotnoTagsAll();

  const deleteTag = useCallback(
    (tag: IApiEntitySmpAgTag) => {
      if (tag.parent) {
        updateSelectedTags(tag.parent, undefined);
      }
    },
    [updateSelectedTags],
  );

  const selectedTagsExtended = useMemo(
    () => dataArraySieve(selectedTags.map((slug) => normalizedTags?.get(slug))),
    [normalizedTags, selectedTags],
  );

  return (
    <UiBox className={classes.wrapper}>
      {selectedTagsExtended.map((tag) => {
        const colorHex =
          tag.parent === "color" ? tag.slug.split("_").at(-1) : undefined;

        return (
          <UiChip
            key={tag.slug}
            label={getTranslation(tag.translations)}
            avatar={
              tag.parent === "color" ? (
                <UiAvatar
                  style={{ background: colorHex ? `#${colorHex}` : undefined }}
                >
                  <span />
                </UiAvatar>
              ) : undefined
            }
            size="small"
            onDelete={() => deleteTag(tag)}
          />
        );
      })}
    </UiBox>
  );
};
